import React from 'react';

import { BottomActionLayout } from '@/components/shared/BottomActionLayout/BottomActionLayout';
import { AsaphButton } from '@/components/shared/Button';
import { classNames } from '@/helpers/classNames';
import { useAnalyticsEvent } from '@/providers/AnalyticsProvider';

import { OnboardingContext } from './Onboarding';
import styles from './Onboarding.module.scss';

const StepOne = () => {
	const { setStep } = React.useContext(OnboardingContext);
	const fireContinue = useAnalyticsEvent('Onboarding_Step1_Continue');

	return (
		<BottomActionLayout
			className={classNames([styles['layout']])}
			listClassName={styles['step-one']}
			actionContent={
				<AsaphButton
					color="blue"
					label="Continue"
					onClick={() => {
						fireContinue();
						setStep(2);
					}}
				/>
			}
		>
			<img
				className={styles['logo']}
				src="/assets/logo-with-title.svg"
				alt="Asaph Logo with Title"
			/>
			<div className={styles['heading']}>Thanks for signing up!</div>
			<div className={classNames([styles['text'], 'mt-sm'])}>
				Let's get you set up and build your first setlist.
			</div>
		</BottomActionLayout>
	);
};

export default StepOne;
